import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { ToolIntervention } from "@app/tool/model/toolIntervention.model";
import { Log } from "ng2-logger";
import { TableComponent } from "@components/custom-table/table.component";

@Component({
    selector: 'app-interventions-table',
    templateUrl: './interventions-table.component.html',
    styleUrls: ['./interventions-table.component.scss']
})
export class InterventionsTableComponent {
    _logger = Log.create(InterventionsTableComponent.name);

    @ViewChild(TableComponent) table: TableComponent;

    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Output() pageChange = new EventEmitter<any>();
    @Input() headerBackgroundColor: string;
    @Input() isMaterial = true;
    @Input() hasTitle = true;
    @Input() canOpenTicketDetails = true;

    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    _interventions = new Array<ToolIntervention>();

    filterResolved = [
        {name: 'All', value: null},
        {name: 'Done', value: true},
        {name: 'Not Done', value: false},
    ];

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info('onRowClick::', clickedItem);
        if (!this.canOpenTicketDetails) {
            return;
        }
        this.rowClick.emit(clickedItem);
    }

    get interventions() {
        return this._interventions;
    }

    @Input()
    set interventions(interventions) {
        this._interventions = interventions;
    }

}
